// extracted by mini-css-extract-plugin
module.exports = {"form":"drugQualityFile_form__dublS","content":"drugQualityFile_content__3ATZP","contentMain":"drugQualityFile_contentMain__3NX9Q","select":"drugQualityFile_select__2cCoB"};